import * as React from 'react'

import { ConnectError } from '@connectrpc/connect'
import { useTranslation } from 'react-i18next'

import { Text } from '@chakra-ui/react'

import {
  DangerButton,
  ModalView,
  TertiaryButton,
  toaster,
} from '@enechain/ecloud-designsystem'

import { useRevokeApiKey } from '~/pages/ApiKeys/hooks/useRevokeApiKey'

type Props = {
  apiKeyId: string
  apiKeyName: string
  open: boolean
  onClose: () => void
  onSuccess: () => void
}
const RevokeApiKeyModal: React.FC<Props> = ({
  apiKeyId,
  apiKeyName,
  open,
  onClose,
  onSuccess,
}) => {
  const { t } = useTranslation()
  const { mutate, isPending, reset } = useRevokeApiKey()

  const onConfirm = (): void => {
    mutate(
      { id: apiKeyId },
      {
        onSuccess: () => {
          toaster.create({
            title: t('pages.api_keys.revoke.success'),
            type: 'success',
          })
          onSuccess()
        },
        onError: (error: ConnectError) => {
          toaster.create({
            title: error.message,
            type: 'error',
          })
        },
      },
    )
  }

  return (
    <ModalView
      title={t('pages.api_keys.revoke.title')}
      open={open}
      onClose={onClose}
      onExitComplete={reset}
      bodyChildren={
        <Text whiteSpace="pre-wrap">
          {t('pages.api_keys.revoke.description', { name: apiKeyName })}
        </Text>
      }
      footerChildren={
        <>
          <TertiaryButton onClick={onClose}>
            {t('action.cancel')}
          </TertiaryButton>
          <DangerButton
            onClick={onConfirm}
            loading={isPending}
            disabled={isPending}
            spinnerPlacement="start"
          >
            {t('pages.api_keys.revoke.confirm')}
          </DangerButton>
        </>
      }
    />
  )
}

export default React.memo(RevokeApiKeyModal)
